<template>
  <div class="header-view">
    <div
      class="header-content-view"
      :style="{
        'padding-left': isWideScreen ? '10%' : '0px',
        'padding-right': isWideScreen ? '10%' : '0px',
      }"
    >
      <!-- logo -->
      <img
        :src="logo"
        class="el-icon-menu"
        style="cursor: pointer"
        @click="goHome"
      />
      <!-- logo的文字  -->
      <span class="logotitle" style="cursor: pointer" @click="goHome">{{
        $t("title")
      }}</span>
      <!-- 导航菜单 -->
      <el-menu
        :class="['mainMenu']"
        router
        :ellipsis="false"
        text-color="#a1a1aa"
        :default-active="activeIndex"
        @select="handleSelect"
        :active-text-color="$colors.primary"
        background-color="#ffffff00"
        mode="horizontal"
        v-if="isWideScreen"
      >
        <!-- 水平平铺的文字菜单 -->
        <el-menu-item class="menuitems" index="/">
          {{ $t("header.home") }}</el-menu-item
        >
        <el-menu-item class="menuitems" index="/privacy">{{
          $t("header.privacy")
        }}</el-menu-item>
        <el-menu-item class="menuitems" index="/qanda">{{
          $t("header.helpcenter")
        }}</el-menu-item>
        <!-- <el-menu-item class="menuitems" index="/member-agreement">{{
          $t("header.member")
        }}</el-menu-item> -->

        <!-- <el-menu-item class="menuitems" index="/privacy">Q&A</el-menu-item> -->
        <!-- <el-menu-item class="menuitems" index="3">关于我们</el-menu-item> -->
      </el-menu>
      <div class="right-view">
        <!-- 语言设置 -->
        <el-dropdown trigger="click">
          <div
            style="
              width: 80px;
              height: 40px;
              line-height: 40px;
              margin: auto;
              padding-top: 10px;
              padding-bottom: 10px;
              cursor: pointer;
              vertical-align: middle;
            "
          >
            <span class="language-selector">
              <!-- {{ currentLocale === "en" ? "English" : "中文" }} -->
              {{ this.$t("yuyan") }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="locale in locales"
              :key="locale.code"
              @click.native="switchLanguage(locale.code)"
            >
              {{ locale.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 下列按钮 -->
        <el-dropdown
          :hide-on-click="true"
          v-if="isShowbtn()"
          trigger="click"
          @command="handleCommand"
          style="margin: auto"
        >
          <span class="el-dropdown-link">
            <el-button class="right-menu-button" type="text">
              <img class="custom-icon" src="../assets/expand.png" />
            </el-button>
          </span>
          <el-dropdown-menu slot="dropdown" router>
            <el-dropdown-item command="/">{{
              $t("header.home")
            }}</el-dropdown-item>
            <el-dropdown-item command="/privacy">{{
              $t("header.privacy")
            }}</el-dropdown-item>
            <el-dropdown-item command="/qanda">{{
              $t("header.helpcenter")
            }}</el-dropdown-item>
            <!-- <el-dropdown-item command="/member-agreement">{{
              $t("header.member")
            }}</el-dropdown-item> -->
            
            <!-- <el-dropdown-item>关于我们</el-dropdown-item> -->
            <!-- <el-dropdown-item disabled>双皮奶</el-dropdown-item>
            <el-dropdown-item divided>蚵仔煎</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>


<script>
import {
  Menu,
  MenuItem,
  Submenu,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
} from "element-ui";

export default {
  name: "HeaderView",
  props: {
    isWideScreen: Boolean,
  },
  components: {
    ElMenu: Menu,
    ElMenuItem: MenuItem,
    ElSubmenu: Submenu,
    ElButton: Button,
    ElDropdown: Dropdown,
    ElDropdownItem: DropdownItem,
    ElDropdownMenu: DropdownMenu,
  },
  data() {
    return {
      activeIndex: "/",
      logo: "https://wgx-bucket.oss-ap-southeast-1.aliyuncs.com/logo.png",
      //isWideScreen: false, // 默认为 true，即屏幕宽度够宽
      currentLocale: "en",
      locales: [],
    };
  },
  mounted() {
    this.currentLocale = this.$i18n.locale;

    // 获取语言列表
    this.fetchLanguageList();
    // 获取用户语言偏好
    this.fetchUserLanguagePreference();

    if (this.$route.path != '/') {
      this.activeIndex = this.$route.path;
    }
  },
  methods: {
    isShowbtn() {
      if (this.isWideScreen) {
        return true;
      } else {
        return false;
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
    //alert(this.$route.name != 'privacy')
  },

  methods: {
    goHome() {
      this.$router.replace("/");
    },
    handleCommand(command) {
      //alert(command);
      this.$router.replace(command)
    },
    // 获取项目中的语言列表
    fetchLanguageList() {
      // 获取语言列表
      const languages = this.$i18n.availableLocales;
      console.log("【语言列表：】" + languages);
      const languageOptions = languages.map((langCode) => {
        return {
          code: langCode, // 语言代码
          name: this.$t(`languageNames.${langCode}`), // 使用 i18n 获取本地化的语言名称
        };
      });

      this.locales = languageOptions;
    },
    // 切换语言
    switchLanguage(locale) {
      this.$i18n.locale = locale; // 设置新的语言环境
    },
    // 获取浏览器的语言
    fetchUserLanguagePreference() {
      // 获取用户的语言偏好
      const userLanguagePreference =
        navigator.language || navigator.userLanguage;
      // 根据用户的语言偏好进行操作
      console.log("User's language preference:", userLanguagePreference);

      // 根据需要设置应用的默认语言
      if (userLanguagePreference.startsWith("zh")) {
        this.$i18n.locale = "zh"; // 假设 'zh' 是应用支持的中文语言代码
      } else {
        this.$i18n.locale = "en"; // 假设 'en' 是应用支持的默认英语语言代码
      }
    },
    handleSelect(key, keyPath) {
      console.log("【中华人民共和国】" + key + "别人" + keyPath);
    },
    isShowbtn() {
      return !this.isWideScreen && this.$route.name != "privacy";
    },
  },
};
</script>

<style scoped>
.header-view {
  background-color: #000000c9;
  width: 100%;
  /* height: 185px; */
  display: flex;
  justify-content: center;
  /* align-items: center; */
}
.header-content-view {
  width: 100%;
  /* min-width: 50px; */
  /* max-width: 1200px; */
  padding-left: 15%;
  padding-right: 15%;
  height: 75px;
  /* margin: auto; */
  vertical-align: middle;
  display: flex;
  justify-content: left;
  align-items: center;
}
.mainMenu {
  width: 99.9% !important;
  border-bottom: 0;
  margin: 0;
  padding-top: 5px;
  padding-left: 25px;
  margin-left: 20px;
  vertical-align: middle;
  align-content: center;
  max-width: 500px;
}
.menuitems {
  font-size: medium;
}
.right-view {
  margin: auto;
  display: flex;
  margin-right: 10px;
}
.down-button {
  /* height: 30px;
  line-height: 30px; */
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  font-weight: 2400;
  margin: auto;
  vertical-align: middle;
}
.down-button:hover {
  background-color: #000000;
  align-content: center;
}
.right-menu-button {
  width: 55px;
  margin-right: 0px;
}
.el-icon-menu {
  height: 50px;
  width: 50px;
  margin-right: 10px;
  margin-left: 15px;
}

.el-menu-item {
  margin-left: 15px;
  margin-right: 25px;
}
.menuIcon {
  height: 50px;
  width: 50px;
  margin-right: 10px;
  margin-left: 35px;
  /* border-radius: 50%; */
}
.custom-icon {
  /* background-image: url("../assets/expand.png");
  background-size: cover; */
  width: 30px; /* 自定义图标的宽度 */
  height: 30px; /* 自定义图标的高度 */
}
.logotitle {
  width: 100px;
  color: white; /* 设置文字颜色为白色 */
  font-size: 1.2rem; /* 设置字体大小，可根据需要调整，使用rem单位确保在不同屏幕尺寸下保持相对一致的可读性 */
  font-weight: bold; /* 设置字体粗细为粗体 */
  font-family: "Playfair Display", serif; /* 设置字体，使用常见的Arial字体，或者选择其他您喜欢的字体 */
  letter-spacing: 0.05em; /* 微调字母间距，使文字看起来更加紧凑 */
  margin: 0; /* 移除默认的外边距 */
  text-align: left; /* 文字居中显示，如果只需要左对齐，可以改为text-align: left; */
}
.language-selector {
  color: white;
  font-size: large;
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderView.vue